// German UI labels — STUB, flagged for translation.
// Intentionally empty: i18next falls back to English (en.js) for every key, so
// the app stays usable while a human translator fills this in. Do NOT
// machine-translate. To translate a market: copy the key structure from en.js,
// translate the values, then set `translated: true` in i18n/languages.js.
// German runs ~30% longer than English; the layouts are built to absorb it.
export default {}
